import React from "react";

import { faCheck, faExclamationTriangle, faSpinner } from "@fortawesome/pro-regular-svg-icons";
import { COLORS } from "rylak-common/src/constants";
import { ENTITY_TYPE, SHIPMENT_BOOKING_STATUS } from "~/constants";
import { CHIP_COLOR_TYPES, ChipTooltip } from "../CustomChip.jsx";
import { EntityActionStatusChipDeprecated } from "../../entityAction/EntityActionStatusChip.jsx";

function Tooltip({ label } = {}) {
    return (
        <ChipTooltip
            title={
                <div>
                    <span style={{ color: COLORS.WEAK_TEXT }}>Booking Status - </span>
                    {label}
                </div>
            }
        />
    );
}

export const SHIPMENT_BOOKING_STATUS_MAP = {
    [SHIPMENT_BOOKING_STATUS.NEW]: {
        colorType: CHIP_COLOR_TYPES.OK,
        label: "Booking",
        icon: faSpinner,
        selectable: false,
        tooltipTitleFn: Tooltip,
    },
    [SHIPMENT_BOOKING_STATUS.BOOKING]: {
        colorType: CHIP_COLOR_TYPES.OK,
        label: "Booking",
        icon: faSpinner,
        selectable: false,
        tooltipTitleFn: Tooltip,
    },
    [SHIPMENT_BOOKING_STATUS.BOOKED]: {
        colorType: CHIP_COLOR_TYPES.DONE,
        label: "Booked",
        icon: faCheck,
        selectable: true,
        tooltipTitleFn: Tooltip,
    },
    [SHIPMENT_BOOKING_STATUS.ERROR]: {
        colorType: CHIP_COLOR_TYPES.ERROR,
        label: "Error",
        icon: faExclamationTriangle,
        tooltipTitleFn: Tooltip,
    },
    [SHIPMENT_BOOKING_STATUS.UPDATE]: {
        colorType: CHIP_COLOR_TYPES.OK,
        label: "Updating",
        icon: faSpinner,
        selectable: false,
        tooltipTitleFn: Tooltip,
    },
};

export function ShipmentBookingStatusChip(props) {
    const { entity } = props;
    return <EntityActionStatusChipDeprecated entityType={ENTITY_TYPE.SHIPMENT} statusData={SHIPMENT_BOOKING_STATUS_MAP[entity?.bookingStatus]} {...props} />;
}
